import { CurrencyPipe } from '@angular/common';
import { ElementRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { asyncScheduler, filter, fromEvent, throttleTime } from 'rxjs';

@Component({
  selector: 'app-event-page-block-live-auction',
  templateUrl: './event-page-block-live-auction.component.html',
  styleUrls: ['./event-page-block-live-auction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CurrencyPipe],
  encapsulation: ViewEncapsulation.None
})
export class EventPageBlockLiveAuctionComponent implements OnInit {

  private _swiperRef = null;
  public swiperEl = null;

  @ViewChild('swiper')
  set swiperRef(swiperRef: ElementRef) {
    this._swiperRef = swiperRef;
    if(this._swiperRef) {
      this.swiperEl = new window['Swiper'](this._swiperRef.nativeElement, this.config);
    }
  };
  get swiperRef(): ElementRef {
    return this._swiperRef;
  }

  @Input() eventPageConfig = null;
  @Input() block = null;
  @Input() index = null;

  public id = '';
  public display = false;
  public title = '';
  public url = '';
  public config = {};

  public presetOptions = [];

  constructor(
    private currencyPipe: CurrencyPipe
  ) {
    fromEvent(window, 'resize').pipe(
      filter(() => this.swiperEl !== null),
      throttleTime(250, asyncScheduler, {
        leading: true,
        trailing: true
      }),
      takeUntilDestroyed()
    ).subscribe(() => {
      this.swiperEl.updateSize();
    });
   }

  ngOnInit(): void {
    this.id = `live-auction-${this.index}`;
    this.display = !this.block.isArchivedOrDeactivated() && !this.block.isCampaignExpaired();
    this.title = this.block.blockTitle || this.block.campaignData.name;
    this.url = `/@${this.eventPageConfig.orgInfo?.handle}@${this.block.campaignData.intid}`;
  
    this.config = {
      autoHeight: true,
      allowTouchMove: true,
      spaceBetween: 20,
      breakpoints: {
        '1160': {
          slidesPerView: 3.5
        },
        '862': {
          slidesPerView: 2.5
        },
        '460': {
          slidesPerView: 1.5
        },
        '0': {
          slidesPerView: 1
        }
      },
      navigation: {
        nextEl: `.swiper-button-next.live-auction-${this.index}`,
        prevEl: `.swiper-button-prev.live-auction-${this.index}`
      },
      centerInsufficientSlides: true,
      loop: false,
      grabCursor: true,
      roundLengths: true,
      virtual: {
        renderSlide: (slide) => {
          const imageUrl = slide.imageUrl || '/images/org_logo_default_v2.svg';

          return `
          <div class="swiper-slide justify-content-center" role="group">
            <div class="card h-100">
              <img class="card-img-top" src="${imageUrl}" />
              <div class="card-body">
                <div class="d-flex flex-column justify-content-between h-100">
                  <div class="card-title">${slide.name}</div>
                  <div class="d-none starting-bid">Starting bid: ${this.currencyPipe.transform(slide.minBid, 'USD', 'symbol-narrow', '1.0-0')}</div>
                </div>
              </div>
            </div>
          </div>`;
        },
        slides: this.block.campaignData.campaignTypeData.presetOptions,
      }
    }
    
    this.presetOptions = this.block.campaignData.campaignTypeData.presetOptions.slice(0, 10);
  }
}
